/***************************************************************************/
"use client";
/***************************************************************************/

import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";

const cardVariants = cva(
  "rounded border shadow-sm bg-background text-card-foreground",
  {
    variants: {
      size: {
        default: "",
        sm: "",
        lg: "rounded-md",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

const CardContext = React.createContext<{
  size?: "default" | "sm" | "lg" | undefined | null;
}>({ size: "default" });

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof cardVariants>
>(({ className, size, ...props }, ref) => {
  return (
    <CardContext.Provider value={{ size }}>
      <div
        ref={ref}
        className={cn(cardVariants({ size }), className)}
        {...props}
      />
    </CardContext.Provider>
  );
});
Card.displayName = "Card";

export { Card, CardContext, cardVariants };
